import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=44a236f6&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=44a236f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a236f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Medias: require('/vercel/path0/components/elements/Medias/index.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
